import { WorkerAction, WorkerActionHandlers } from '../utils';
import printHandler from './printHandler';

const workerHandlers: WorkerActionHandlers = {
  [WorkerAction.PRINT_KITCHEN_DOCKET]: printHandler,
};
export default workerHandlers;
